module.exports = __webpack_public_path__ + "img/6.8eba2bb9.png";